"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var notifications_1 = require("../stores/notifications");
function showInAppNotification(data) {
    var action = function (dispatch) {
        var _a, _b, _c, _d, _e;
        var expireAfterAt = data.expireAfter ? Date.now() + data.expireAfter : false;
        var expireAt = data.expireAt ? data.expireAt : expireAfterAt;
        if (expireAt && expireAfterAt) {
            expireAt = Math.min(expireAt, expireAfterAt);
        }
        dispatch((0, notifications_1.addNotification)({
            id: (_a = data.id) !== null && _a !== void 0 ? _a : "".concat(data.type, "_").concat(Date.now(), "_").concat(Math.floor(Math.random() * 100)),
            type: data.type,
            text: data.text,
            key: (_b = data.key) !== null && _b !== void 0 ? _b : false,
            priority: (_c = data.priority) !== null && _c !== void 0 ? _c : 0,
            actions: (_d = data.actions) !== null && _d !== void 0 ? _d : [],
            closable: (_e = data.closable) !== null && _e !== void 0 ? _e : true,
            expireAt: expireAt,
            onAction: data.onAction,
        }));
    };
    action.type = "showNotification";
    return action;
}
exports.default = showInAppNotification;
//# sourceMappingURL=showNotification.js.map